const SERVER_URL_DEV = 'http://127.0.0.1:4000';
const SERVER_URL_PROD = 'https://nomad-admin.com';

export const SERVER_URL = SERVER_URL_PROD; // change server url
